module.exports = __webpack_public_path__ + "static/img/qh1-3.a2801bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/qh1-3.png
// module id = 704
// module chunks = 0